import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { TStencilStore } from '../../../types/Stencil';
import { setOptInNewsletter } from '../../../actions/stencils/editor';

function Newsletter() {
  const dispatch = useDispatch();
  const optIn = useSelector(
    (state: TStencilStore) => state.submission.optInNewsletter
  );

  const setValue = useCallback(
    (newValue) => {
      dispatch(setOptInNewsletter(newValue));
    },
    [dispatch]
  );

  return (
    <div className="c-form-group stencil-form-newsletter">
      <label className="c-form-label">Newsletter</label>
      <div className="c-form-checkbox-group">
        <input
          type="checkbox"
          name="opt_in_newsletter"
          id="opt_in_newsletter"
          className="c-form-checkbox"
          value={optIn}
          onChange={(e) => setValue(e.target.checked)}
        />
        <label className="c-form-checkbox-label" htmlFor="opt_in_newsletter">
          Join our newsletter for sneak peeks on product launches, memory book
          tips, and exclusive discounts.
        </label>
      </div>
    </div>
  );
}

export default Newsletter;
